<template>
  <!-- 表格底部-->
  <tfoot class="table-tfoot">
    <tr class="row">
      <slot></slot>
    </tr>
    <tr class="addRow" v-if="isHide">
      <td :colspan="colspan">
        <span @click="$emit('addRow')">
          <img src="../../../public/img/icon_add_line.png" alt="" />
          增行
        </span>
        <span @click="$emit('delRow')">
          <img src="../../../public/img/icon_del_rows.png" alt="" />
          删行</span
        >
      </td>
    </tr>
    <tr
      class="row"
      v-show="
        $route.name != 'salesAdd' &&
        $route.name != 'addEdCardTable' &&
        $route.name != 'purchaseAdd' &&
        $route.name !== 'addExpenseRecord' &&
        $route.name !== 'addLoss' &&
        $route.name !== 'addTurnPond' &&
        $route.name !== 'addProofing' &&
        $route.name !== 'addFeeding' &&
        $route.name !== 'addPrevention'
      "
    >
      <td>抹零</td>
      <td-ex
        :colspan="colspan - 1"
        type="input"
        number
        :bindValue="smallChangeAmount"
        @changeModel="updateSmallChangeAmount"
      />
    </tr>
    <tr v-if="$route.name == 'salesAdd'" class="row">
      <td>抹零</td>
      <td-ex
        :colspan="1"
        type="input"
        number
        :bindValue="smallChangeAmount"
        @changeModel="updateSmallChangeAmount"
      />
      <td>折扣金额</td>
      <td-ex
        :colspan="1"
        type="input"
        number
        :bindValue="discountAmount"
        @changeModel="updateDiscountAmount"
      />
      <td>优惠券金额</td>
      <td>{{ couponAmount }}</td>
      <!-- <td-ex :colspan="1" type="input" number :bindValue="couponAmount" @changeModel="updateCouponAmount"/> -->
      <td>应收金额</td>
      <td>{{ receivableAmount }}</td>
      <td>实收金额</td>
      <td-ex
        :colspan="colspan - 7"
        type="input"
        number
        :class="{ readyOnly: actualAmountDisabled }"
        :bindValue="actualAmount"
        @changeModel="updateActualAmount"
      />
    </tr>
    <tr v-if="$route.name == 'purchaseAdd'" class="row">
      <td>实付金额</td>
      <td-ex
        :colspan="colspan - 1"
        type="input"
        number
        :class="{ readyOnly: actualAmountDisabled }"
        :bindValue="actualAmount"
        @changeModel="updateActualAmount"
      />
    </tr>
    <tr class="row">
      <td>备注</td>
      <!-- <td :colspan="colspan-1" class="remark">
        <input :value='remark' @input="updateRemark" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" type="text" :maxlength="num50" />
      </td> -->
      <td-ex
        :colspan="colspan - 1"
        type="input"
        :bindValue="remark"
        @changeModel="updateRemark"
      />
    </tr>
  </tfoot>
</template>

<script>
import TdEx from "./TdEx.vue";
export default {
  name: "TfootEx",
  components: { TdEx },
  props: {
    isHide: {
      type: Boolean,
    },
    actualAmountDisabled: {
      type: Boolean,
    },
    remark: String,
    smallChangeAmount: {
      type: Number,
    },
    discountAmount: Number,
    couponAmount: Number,
    receivableAmount: Number,
    actualAmount: Number,
  },
  model: {
    prop: "remark",
    event: "update:remark",
  },
  data() {
    return {
      disabled: false,
      colspan: 0,
      num50: 50,
    };
  },
  mounted() {
    console.log(223333333, this.actualAmountDisabled);

    this.disabled = this.actualAmountDisabled;
    let units = this.$slots.default.filter((f) => f.tag);
    this.colspan = units.length;
  },
  methods: {
    updateRemark(e) {
      this.$emit("update:remark", e);
    },
    updateSmallChangeAmount(e) {
      this.$emit("update:smallChangeAmount", Number(e));
    },
    updateActualAmount(e) {
      this.$emit("update:actualAmount", Number(e));
    },
    updateDiscountAmount(e) {
      this.$emit("update:discountAmount", Number(e));
    },
    updateCouponAmount(e) {
      this.$emit("update:youhuiAmount", Number(e));
    },
  },
  computed: {
    smallChangeAmountNum(value) {
      value = Number(value);
      return isNaN(value) ? 0 : value;
    },
  },
};
</script>

<style lang="stylus" scoped>
.readyOnly {
  cursor: not-allowed;
}
.readyOnly {
  color:red;
  pointer-events: none;
  background: #f5f7fa;
}
.table-tfoot
  tr>td
    text-align center
    height 40px
    line-height 37px
    color: #333;
    font-size: 14px;

  .row
    font-size 14px
    background-color #fff
    // color #ff4848
    font-weight bold

    >td
      text-align center
      border 1px solid #e0e0e0
  .addRow
    td
      text-align left
      height 37px
      line-height 37px
      background-color #fff
      border 1px solid #e0e0e0
      // border-bottom 1px solid #e0e0e0
      >span:first-child
        padding-left 30px;
      >span:last-child
        padding-left 20px
      >span
        display inline-block
        font-weight bold
        font-size 14px
        color #ff4848
        cursor pointer
        position relative
        >img
          position absolute;
          top:12px;
          right:35px;

        &:nth-child(1)
          // margin 0 20px
          color rgba(51, 137, 255, 1);

        &:nth-child(2)
          margin 0 20px
</style>
